<template>
  <div class="container-fluid promotion-page p-2 pt-3">
    <div class="promotion-page__inner">
      <div class="col-12 px-1 mb-5 pb-5">
        <div
          class="card bg-transparent mt-2 promotion-card"
          v-for="(promotion, proIndex) in promotions"
          :key="proIndex"
        >
          <a href="#">
            <img
              class="promotion-card__image"
              :src="promotion.image"
              :alt="promotion.title"
            >
          </a>
          <div class="px-3 py-2 d-flex justify-content-between bg-transparent">
            <h3 class="text-dark my-auto">
              {{ promotion.title }}
            </h3>
            <button
              class="detail-button col-3"
              @click="openPromotion(proIndex)"
            >
              {{ $t('detail') }}
            </button>
          </div>

          <van-overlay
            :show="selectedPromotion === proIndex"
            @click="selectedPromotion = null"
          >
            <div class="wrapper col-12 d-flex h-100vh">
              <div class="col-11 card mx-auto my-auto py-4 px-3 promotion-overlay__card">
                <h2 class="pb-3 promotion-overlay__title">
                  {{ promotion.title }}
                </h2>
                <span
                  class="promotion-overlay__description"
                  v-html="promotion.description"
                ></span>
              </div>
            </div>
          </van-overlay>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedPromotion: null,
      promotions: [
        {
          title: 'မန်ဘာသစ်ဘောနပ်စ် 100%',
          description: `
                        📌 12K ၏မန်ဘာသစ်တိုင်း (𝟏) ကြိမ်သာ ရယူနိုင်ပါသည်။ <br><br>
                        📌 အနည်းဆုံးသွင်းငွေ ကျပ် 5,𝟎𝟎𝟎 အထက်ရှိရမည်။ <br><br>
                        📌 အမြင့်ဆုံးရယူနိုင်သည့်ဘောနပ်စ်မှာ ကျပ် ၃၀,၀၀၀ ဖြစ်ပါသည်။ <br><br>
                        📌 ဘောနပ်ယူပါက Free spin လုံးဝမဝယ်ရ။ <br><br>
                        📌 Turnover 𝟏𝟎  ဆ ပြည့်မှသာငွေထုတ်နိုင်မည်။ [( သွင်းငွေ+ဘောနပ်စ် ) x 10  ] <br><br>
                        ❌❌❌ 𝐒𝐋𝐎𝐓 အတွက် 𝐅𝐫𝐞𝐞 𝐬𝐩𝐢𝐧 မဝယ်ရ ၊ စစ်ဆေးတွေ့ရှိပါကငွေထုတ်ပေးမည်မဟုတ်ပါ။ <br><br>
                        📌 အမြင့်ဆုံးထုတ်ယူနိုင်သည့် ပမာဏသည် 𝟏𝟎 ဆ ဖြစ်ပြီး ကျန်ယူနစ်များအား 𝐬𝐞𝐫𝐯𝐞𝐫 မှ အော်တိုနုတ်ယူသွားမည်ဖြစ်သည်။`,
          image: '/assets/Banner1.webp',
        },
        {
          title: 'နေ့စဉ်ဘောနပ်စ် 20% (တစ်နေ့ 1 ကြိမ်)',
          description: `📌 12K ၏မန်ဘာဟောင်းတိုင်းတစ်ရက် (𝟏) ကြိမ်ရယူနိုင်သည်။ <br><br>
                        📌 အနည်းဆုံးသွင်းငွေ ကျပ် ၃,၀၀၀ အထက်ရှိရမည်။ <br><br>
                        📌 အမြင့်ဆုံးရယူနိုင်သည့်ဘောနပ်စ်မှာ ကျပ် ၃၀,၀၀၀ ဖြစ်ပါသည်။ <br><br>
                        📌 Turnover 4  ဆ ပြည့်မှသာငွေထုတ်နိုင်မည်။ [( သွင်းငွေ+ဘောနပ်စ် ) x ၄  ] <br><br>
                        📌 𝐒𝐋𝐎𝐓 အတွက် 𝐅𝐫𝐞𝐞 𝐬𝐩𝐢𝐧 မဝယ်ရ ၊ စစ်ဆေးတွေ့ရှိပါကငွေထုတ်ပေးမည်မဟုတ်ပါ။ <br><br>
                        📌 ကန့်သတ်ချက်မရှိ ငွေထုတ်ယူနိုင်ပါသည်။ <br><br>`,
          image: '/assets/Banner2.webp',
        },
        {
          title: 'ရှူံးကြေးပြန်အမ်းငွေဘောနပ်စ် 5%',
          description: `📌 တစ်ရက်အတွင်း ရှူးထားသောငွေ၏ 5% ကိုပြန်ရယူနိုင်ပါသည် ။ <br><br>
                        📌 ရှူံးကြေးကို ည 3 နာရီမှသုံးနာရီနောက်ပိုင်းတွင် system မှ auto ပြန်အမ်းပေးပါသည် ။ <br><br>
                        📌 နိုင်ငွေ 1 ဆ ပြည့်မှသာငွေထုတ်ပေးပါမည် ။ <br><br>
                        📌 နိုင်ငွေ ပြည့်ပြီးပါက ကန့်သတ်ချက်မရှိ ငွေပြန်လည်ထုတ်ယူနိုင်ပါသည် ။ <br><br>`,
          image: '/assets/Banner3.webp',
        },
        {
          title: 'သွင်းတိုင်းရ 5%',
          description: `📌 အနည်းဆုံး ၅,𝟎𝟎𝟎 ကစသွင်းပါကဒီပရိုမိုးရှင်းရနိုင်ပါသည်။ <br><br>
                        📌 အမြင့်ဆုံးရယူနိုင်သည့် 𝐁𝐨𝐧𝐮𝐬 မှာ ငွေကျပ် ၃၀,၀၀၀ ဖြစ်ပါသည်။ <br><br>
                        📌 နိုင်ငွေ 3ဆ ပြည့်မှသာ ငွေထုတ်ပေးပါမည်။ [( သွင်းငွေ+ဘောနပ်စ် ) x၃]<br><br>
                        📌 နိုင်ငွေ ပြည့်ပြီးပါက ကန့်သတ်ချက်မရှိ ငွေပြန်လည်ထုတ်ယူနိုင်ပါသည်။ <br><br>`,
          image: '/assets/Banner1.webp',
        },
      ],
    };
  },
  methods: {
    openPromotion(index) {
      this.selectedPromotion = index;
    },
  },
};
</script>

<style scoped>
.promotion-page {
  height: 100vh;
  overflow-y: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
  background: #F5F7F5;
  background-size: cover;
  background-attachment: fixed;
  padding-bottom: 15rem;
}

.promotion-page__inner {
  height: 130vh;
}

.promotion-card {
  overflow: hidden;
  border: 1px solid #D0DBD3 !important;
  border-radius: 12px !important;
  background: #F5F7F5 !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.28);
}

.promotion-card h3 {
  color: #1A2E1F !important;
  font-size: 0.95rem;
  line-height: 1.35;
}

.promotion-card__image {
  display: block;
  border-radius: 11px 11px 0 0;
  width: 100%;
}

.promotion-overlay__card {
  background: #F5F7F5 !important;
  border: 1px solid rgba(13, 59, 26, 0.38);
  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.48);
}

.promotion-overlay__title {
  color: #082612;
}

.promotion-overlay__description {
  color: #2D4A35;
}

.detail-button {
  appearance: none;
  background: #0D3B1A;
  border: 1px solid #E8B923;
  text-transform: uppercase;
  border-radius: 14px;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-family: Roobert, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 0.9rem;
  font-weight: 700;
  line-height: normal;
  margin: 0;
  min-height: 15px;
  min-width: 0;
  outline: none;
  padding: 1px 5px;
  text-align: center;
  text-decoration: none;
  transition: all 300ms cubic-bezier(.23, 1, 0.32, 1);
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  width: 100%;
  will-change: transform;
  box-shadow: 0 5px 14px rgba(8, 38, 18, 0.28);
}

.detail-button:disabled {
  pointer-events: none;
}

.detail-button:hover {
  color: #fff;
  background: #0D3B1A;
  border-color: #E8B923;
  transform: translateY(-2px);
}

.detail-button:active {
  box-shadow: none;
  transform: translateY(0);
  background: #0D3B1A;
  border-color: #082612;
}
</style>
